import { fail, numberOf, objectOf } from '../../../shared/api/wire'

export interface AqsiPrintSettings {
  deviceId: number
  printSlipCount: number
  version: number
  /** Оплата по QR-коду СБП на терминале этой кассы — действующее значение (своё или источника; по умолчанию включена). */
  acceptQr: boolean
  /** «Быстрая оплата» (решение владельца 24.10.2026): чек печатается фоном, кассир сразу набирает следующую продажу. Старый сервер поле не шлёт — выключена. */
  fastPayment: boolean
}

export function decodePrintSettings(raw: unknown, deviceId: number): AqsiPrintSettings {
  const data = objectOf(raw, 'настройка печати')
  const count = numberOf(data.printSlipCount, 'printSlipCount')
  const version = numberOf(data.version, 'version')
  if (data.deviceId !== deviceId) fail('Ответ настройки печати другой кассы')
  if (!Number.isInteger(count) || count < 0 || count > 2) fail('Количество слипов — 0, 1 или 2')
  if (!Number.isSafeInteger(version) || version < 1) fail('Некорректная версия настройки печати')
  if (data.acceptQr !== undefined && data.acceptQr !== null && typeof data.acceptQr !== 'boolean') fail('acceptQr — да или нет')
  if (data.fastPayment !== undefined && data.fastPayment !== null && typeof data.fastPayment !== 'boolean') fail('fastPayment — да или нет')
  return { deviceId, printSlipCount: count, version, acceptQr: data.acceptQr !== false, fastPayment: data.fastPayment === true }
}
